var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main" }, [
    _c("div", { staticClass: "title" }),
    _c(
      "div",
      { staticClass: "content scrollable" },
      [
        _c(
          "el-row",
          [
            _c(
              "el-col",
              { staticClass: "a", attrs: { span: 12 } },
              [
                _vm.index
                  ? _c("ik-bar-stack-chart", {
                      attrs: {
                        code: "1",
                        height: "300px",
                        title: "接诊情况",
                        data: _vm.doctorweekdiag,
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _c(
              "el-col",
              { staticClass: "a", attrs: { span: 12 } },
              [
                _vm.index
                  ? _c("ik-line-time-chart", {
                      attrs: {
                        code: "2",
                        height: "300px",
                        title: "客流趋势",
                        data: _vm.storeweekdiag,
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _c(
              "el-col",
              { staticClass: "a", attrs: { span: 6 } },
              [
                _vm.index
                  ? _c("ik-pie-base-chart", {
                      attrs: {
                        code: "4",
                        height: "300px",
                        title: "库存构成",
                        data: _vm.storeinventory,
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _c(
              "el-col",
              { staticClass: "a", attrs: { span: 18 } },
              [
                _vm.index
                  ? _c("ik-line-time-chart", {
                      attrs: {
                        code: "5",
                        height: "300px",
                        title: "销售构成",
                        data: _vm.storeweekpay,
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-row",
          { staticClass: "combined-section" },
          [
            _c("el-col", { attrs: { span: 12 } }, [
              _c(
                "div",
                { staticClass: "section-header" },
                [
                  _c("span", { staticClass: "section-title" }, [
                    _vm._v("运营数据"),
                  ]),
                  _c(
                    "el-radio-group",
                    {
                      staticClass: "time-switch",
                      attrs: { size: "small" },
                      model: {
                        value: _vm.timeRange,
                        callback: function ($$v) {
                          _vm.timeRange = $$v
                        },
                        expression: "timeRange",
                      },
                    },
                    [
                      _c("el-radio-button", { attrs: { label: "day" } }, [
                        _vm._v("日"),
                      ]),
                      _c("el-radio-button", { attrs: { label: "week" } }, [
                        _vm._v("周"),
                      ]),
                      _c("el-radio-button", { attrs: { label: "month" } }, [
                        _vm._v("月"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "table-card unified-table" },
                [
                  _c(
                    "el-table",
                    {
                      attrs: {
                        data: _vm.filteredData,
                        height: "400",
                        size: "small",
                        border: "",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "time",
                          label: _vm.timeLabel,
                          width: "100",
                          align: "center",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "detectCount",
                          label: "检测人数",
                          width: "100",
                          align: "center",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "detectCount",
                          label: "检测未付费人数",
                          width: "100",
                          align: "center",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "detectCount",
                          label: "检测已付费人数",
                          width: "100",
                          align: "center",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "revenue",
                          label: "销售额",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      color: "#409EFF",
                                      "font-weight": "500",
                                    },
                                  },
                                  [_vm._v("¥" + _vm._s(scope.row.revenue))]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "revenue",
                          label: "收益流水",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      color: "#409EFF",
                                      "font-weight": "500",
                                    },
                                  },
                                  [_vm._v("¥" + _vm._s(scope.row.revenue))]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("el-col", { attrs: { span: 12 } }, [
              _c("div", { staticClass: "section-header" }, [
                _c("span", { staticClass: "section-title" }, [
                  _vm._v("全国热力分析"),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "table-card unified-table" },
                [
                  _c(
                    "el-table",
                    {
                      attrs: {
                        data: _vm.heatMapData,
                        height: "400",
                        size: "small",
                        border: "",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "province",
                          label: "省",
                          width: "120",
                          align: "center",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "city",
                          label: "市",
                          width: "120",
                          align: "center",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "detectCount",
                          label: "检测人数",
                          width: "100",
                          align: "center",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "scanAmount",
                          label: "扫码金额",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      color: "#409EFF",
                                      "font-weight": "500",
                                    },
                                  },
                                  [_vm._v("¥" + _vm._s(scope.row.scanAmount))]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }